import store from "@/(front-desk)/store";
import axios from "axios";
import lscache from "lscache";

/**
 * @param {object} params
 * @param {AbortSignal} params.signal
 * @returns {Promise<JudgeProcess>}
 */
export async function fetchMissions({ signal }) {
  const headers = {
    Authorization: `Bearer ${lscache.get("access")}`,
  };

  const currentCompeteYear = store.getState().global.currentCompeteYear
  const resp = await axios.get(`/api/v1/competition/${currentCompeteYear}/judge/process`, {
    headers,
    signal,
  })
  .catch((err) => {
    if (err.response?.data?.code == '1003') {
      location.href = '/user'
    }
  })

  if (resp.data.code !== 0) throw new Error(resp.data.error);

  return resp.data.body;
}

/**
 *
 * @param {object} params
 * @param {string} params.subcategory
 * @param {number} params.stage
 * @param {number?} params.page
 * @param {number?} params.page_size
 * @param {JudgeProjectQueryParams?} params.filter
 * @param {AbortSignal} params.signal
 * @returns {Promise<JudgeProjectPaging>}
 */
export async function fetchProjects({
  subcategory,
  stage,
  page = 1,
  page_size = 10,
  filter = {},
  signal,
}) {
  const headers = {
    Authorization: `Bearer ${lscache.get("access")}`,
  };

  const params = { ...filter, page, page_size };

  // remove empty params to prevent unexpected behavior
  if (!params.search) delete params.search;
  if (!params.order) delete params.order;
  if (!params.range) delete params.range;

  const search = new URLSearchParams(params).toString();

  const currentCompeteYear = store.getState().global.currentCompeteYear
  const resp = await axios.get(
    `/api/v1/competition/${currentCompeteYear}/judge/${subcategory}/${stage}/projects?${search}`,
    { headers, signal }
  );

  if (resp.data.code !== 0) throw new Error(resp.data.error);

  // @TODO handle pagination

  return resp.data.body;
}

/**
 * @param {object} params
 * @param {number} params.id
 * @param {AbortSignal} params.signal
 * @returns {Promise<JudgeProjectDetail>}
 */
export async function fetchProjectDetail({ id, signal }) {
  const headers = {
    Authorization: `Bearer ${lscache.get("access")}`,
  };

  const currentCompeteYear = store.getState().global.currentCompeteYear
  const resp = await axios.get(
    `/api/v1/competition/${currentCompeteYear}/judge/projects/${id}`,
    { headers, signal }
  );

  if (resp.data.code !== 0) throw new Error(resp.data.error);

  return resp.data.body;
}

/**
 * @param {object} params
 * @param {number} params.id
 * @param {AbortSignal} params.signal
 * @returns {Promise<JudgeProjectPeek>}
 */
export async function fetchProjectApplicants({ id, phase, signal }) {
  const headers = {
    Authorization: `Bearer ${lscache.get("access")}`,
  };

  const currentCompeteYear = store.getState().global.currentCompeteYear
  const resp = await axios.get(
    `/api/v1/competition/${currentCompeteYear}/judge/peek/${phase}/projects/${id}`,
    { headers, signal }
  );

  if (resp.data.code !== 0) throw new Error(resp.data.error);

  return resp.data.body;
}

/**
 * @param {object} params
 * @param {number} params.id
 * @param {JudgeReviewDraft} params.draft
 * @param {AbortSignal} params.signal
 * @return {Promise<JudgeProjectDetail>}
 */
export async function submitReview({ id, draft, signal }) {
  const headers = {
    Authorization: `Bearer ${lscache.get("access")}`,
  };

  const currentCompeteYear = store.getState().global.currentCompeteYear
  const resp = await axios.post(
    `/api/v1/competition/${currentCompeteYear}/judge/projects/${id}/reviews`,
    draft,
    { headers, signal }
  );

  if (resp.data.code !== 0) throw new Error(resp.data.error);

  return resp.data.body;
}

/**
 * @param {object} params
 * @param {string} params.type
 * @param {AbortSignal} params.signal
 * @return {Promise<Stage[]>}
 */
export async function fetchStages({ type, signal }) {
  const headers = {
    Authorization: `Bearer ${lscache.get("access")}`,
  };

  const currentCompeteYear = store.getState().global.currentCompeteYear
  const resp = await axios.get(`/api/v1/activity/years/${currentCompeteYear}/${type}/stages`, {
    headers,
    signal,
  });

  if (resp.data.code !== 0) throw new Error(resp.data.error);

  return resp.data.body;
}
